// Importa Vue per utilizzare Vue.cookies se non sei in un componente Vue
import Vue from 'vue';

export default function authHeader() {
    try {
        const userToken = JSON.parse(window.localStorage.getItem('token'));

        // Utilizza Vue.cookies per ottenere il valore del token CSRF
        const csrfToken = Vue.$cookies.get('csrftoken');

        const headers = {
            'X-CSRFToken': csrfToken
        };

        // Aggiungi Authorization solo se il token è valido
        if (userToken && userToken !== 'null') {
            headers.Authorization = 'Token ' + userToken;
        }

        return headers;
    } catch (e) {
        console.warn('Errore nel parsing del token:', e);
        return {
            'X-CSRFToken': Vue.$cookies.get('csrftoken')
        };
    }
}
